import { pathOr } from '@xingternal/malt-util';

export const activeItemSelector = ({ activeItem }) => activeItem;
export const userSelector = (state) => pathOr({}, ['user'], state);
export const hashedUserIdSelector = (state) =>
  pathOr('', ['hashedUserId'], state);
export const hasUserSelector = (state) => pathOr(false, ['hasUser'], state);
export const hasActiveSearchBarSelector = (state) =>
  pathOr(false, ['hasActiveSearchBar'], state);
export const notificationsSelector = ({ notifications }) => notifications;
export const notificationCenterWebCountSelector = (state) =>
  pathOr(0, ['notifications', 'notificationCenterWeb'], state);
export const loadingAppStatsQuerySelector = ({ loadingAppStatsQuery }) =>
  loadingAppStatsQuery;
export const loadingMainQuerySelector = ({ loadingMainQuery }) =>
  loadingMainQuery;
export const loginStateSelector = ({ loginState }) => loginState;
export const offsetTopSelector = (state) => pathOr(0, ['offsetTop'], state);
export const browserBarOpenSelector = (state) =>
  pathOr(false, ['browserBarOpen'], state);

// Features
export const featuresSelector = ({ features }) => features;
export const featuresIsPremiumSelector = ({ features }) =>
  pathOr(false, ['isPremium'], features);
export const featuresIsBasicSelector = ({ features }) =>
  pathOr(false, ['isBasic'], features);
export const featuresIsProJobsSelector = ({ features }) =>
  pathOr(false, ['hasProJobsMembership'], features);
export const featuresIsProBusinessSelector = ({ features }) =>
  pathOr(false, ['showProbusinessInNavigation'], features);
export const featuresIsExecutiveSelector = ({ features }) =>
  pathOr(false, ['isExecutive'], features);
export const featuresIsBrandManageEditorSelector = ({ features }) =>
  pathOr(false, ['isBrandManagerEditor'], features);
export const featuresShowUpsellHintSelector = ({ features }) =>
  pathOr(false, ['showUpsellHint'], features);
export const featuresShowJobSeekerBoneyardUpsellHintSelector = ({ features }) =>
  pathOr(false, ['showJobSeekerBoneyardUpsellHint'], features);

// FeatureSwitches
export const featureSwitchesSelector = (state) =>
  pathOr([], ['featureSwitches'], state);
export const armstrongV1Selector = (state) =>
  (pathOr([], ['featureSwitches'], state) || []).includes('armstrong_v1');

export const armstrongV2LogoutInSettingsSelector = (state) =>
  (pathOr([], ['featureSwitches'], state) || []).includes(
    'armstrong_v2_logout_in_settings'
  );
export const armstrongMarketingEntryPointMenuSelector = (state) =>
  (pathOr([], ['featureSwitches'], state) || []).includes(
    'armstrong_marketing_entry_point_menu'
  );
export const messengerTopBarLinkSelector = (state) =>
  (pathOr([], ['featureSwitches'], state) || []).includes(
    'enable_armstrong_separate_message_rollout'
  );

//  hasProJobsMembership
export const featuresHasCoachProfileSelector = ({ features }) =>
  pathOr(false, ['hasCoachProfile'], features);
export const featuresIsCraUserSelector = ({ features }) =>
  pathOr(false, ['isCraUser'], features);
export const featuresIsSeatManagerAdminSelector = ({ features }) =>
  pathOr(false, ['isSeatManagerAdmin'], features);
export const featuresIsJobsPosterSelector = ({ features }) =>
  pathOr(false, ['isJobsPoster'], features);
export const featuresIsBrandPageCollaboratorSelector = ({ features }) =>
  pathOr(false, ['isBrandPageCollaborator'], features);
export const featuresIsAdmasterUserSelector = ({ features }) =>
  pathOr(false, ['isAdmasterUser'], features);
